import React from "react";
import "../assets/styles/footer.css";
import MainLogo from "../assets/image/mainLogo.gif";
import CopyrightIcon from "@mui/icons-material/Copyright";
const Footer = () => {
  return (
    <div className="footer_container">
      <footer>
        <img
          style={{ height: "50px", width: "50px" }}
          src={MainLogo}
          alt="MainLogo"
        />
        <p>
          <CopyrightIcon style={{ marginRight: "5px" }} /> 2022 JUNAID All
          Rights Reserved.
        </p>
      </footer>
    </div>
  );
};

export default Footer;
